import { Layout } from 'antd';
import React, { ReactElement } from 'react';
import FooterComponent from '../../../shared/components/FooterComponent';
import HeaderMenu from '../../Layout/components/HeaderMenu';
import WMSMenuList from '../components/WMSMenuList';
import WMSRoutes from '../components/WMSRoutes';

const { Content, Sider } = Layout;

const WMSPage = (): ReactElement => {
  return (
    <>
      <HeaderMenu title="仓库系统" />
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible breakpoint="xl" theme="light">
          <WMSMenuList />
        </Sider>
        <Layout>
          <Content
            style={{
              padding: 24,
              margin: '24px 16px 0 16px',
              minHeight: '200px',
              background: '#fff'
            }}
          >
            <WMSRoutes />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default WMSPage;
